<template>
  <div>
    <wmt-topBg :src='topImg'></wmt-topBg>
    <wmt-arriveDetail></wmt-arriveDetail>
    <wmt-arriveMap></wmt-arriveMap>
  </div>
</template>

<script>
import wmtArriveMap from '../../components/wmt-arrive/wmt-arriveMap.vue';
import wmtArriveDetail from '../../components/wmt-arrive/wmt-arriveDetail.vue';
import wmtTopBg from '../wmt-topBg/wmt-topBg.vue';

export default {
  name: 'wmt-arrive',
  components:{
    wmtArriveMap,
    wmtArriveDetail,
    wmtTopBg
  },
  data() {
    return {
      topImg: `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/arrive-m.png?v=${new Date()}`,
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="less" scoped>

.item {
  margin-top: 60px;
  .name {
    font-size: 30px;
    font-weight: 500;
    color: #3e3a39;
    text-align: center;
    width: 100%;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #ebebeb;
    margin-top: 25px;
    margin-bottom: 36px;
  }
  .itembox {
    display: grid;
    /* grid-gap: 30px 50px */
    grid-column-gap: 10px;
    grid-row-gap: 30px;
    /* 一行放两列、两个auto */
    grid-template-columns: auto auto auto auto;
    justify-content: center;
    .logoItem {
      width: 320px;
      height: 94px;
      border: 1px solid rgba(151, 151, 151, 0.25);
    }
  }
}
</style>